import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PlayVideo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const model = location.state?.model;

  if (!model) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        backgroundColor: '#000', 
        color: '#fff',
        fontFamily: 'inherit'
      }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ marginBottom: '20px', fontSize: '1.2rem' }}>No video selected</p>
          <button 
            onClick={() => navigate(-1)}
            style={{
              padding: '10px 25px',
              borderRadius: '30px',
              border: '1px solid #fff',
              background: 'transparent',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.98)',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      boxSizing: 'border-box',
      backdropFilter: 'blur(10px)'
    }}>
      {/* Premium Close Button */}
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          color: 'white',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(5px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          zIndex: 10000
        }}
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            transform: 'scale(1.1) rotate(90deg)',
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        <CloseIcon sx={{ fontSize: 30 }} />
      </IconButton>

      <div style={{ 
        width: '100%', 
        maxWidth: '1100px', 
        maxHeight: '90vh',
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        justifyContent: 'center',
        animation: 'playVideoFadeInUpAdmin 0.6s ease-out',
        position: 'relative'
      }}>
        <h2 style={{ 
          color: 'white', 
          marginBottom: '20px', 
          fontWeight: '500', 
          fontSize: 'clamp(1.2rem, 4vw, 1.8rem)',
          textAlign: 'center',
          textShadow: '0 2px 10px rgba(0,0,0,0.5)',
          fontFamily: 'inherit',
          width: '100%',
          padding: '0 40px'
        }}>
          {model.title}
        </h2>
        
        <div style={{ 
          width: '100%',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#000',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 25px 60px rgba(0,0,0,0.8)',
          position: 'relative',
          maxWidth: '100%',
          aspectRatio: '16/9'
        }}>
          <ReactPlayer
            url={model.videoUrl}
            playing={true}
            controls={true}
            width="100%"
            height="100%"
          />
        </div>
      </div>

      <style>
        {`
          @keyframes playVideoFadeInUpAdmin {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default PlayVideo;